import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerTiersService } from '../retailer-tiers.service';

@Component({
  selector: 'app-all-tiers',
  templateUrl: './all-tiers.component.html',
  styleUrls: ['./all-tiers.component.scss']
})
export class AllTiersComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  searchValue: string;
  rowSelection
  rowData
  columnDefs
  private gridApi;
  private gridColumnApi;
  selectedRows: any;
  showUpdateRetailer: boolean;
  retailerTierId: any;
  constructor(private retailerTierService: RetailerTiersService) {
    super();
    this.getAllTiersData()
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  getAllTiersData() {
    this.retailerTierService.getRetailerTiers().subscribe(res => {
      if (res['httpcode'] == 200) {
        this.setGrid(res.data)
      }
    })
  }

  setGrid(data: any) {
    this.rowData = data;
    this.rowSelection = 'single';

    this.columnDefs = [
      { field: 'retailerTierId', headerName: 'retailerId', width: 0, hide: true, sort: "desc" },
      { field: '', headerName: 'Action', width: 50, checkboxSelection: true },
      { field: 'retailerTierName', headerName: 'Retailer Tier Name', width: 300 },
      { field: 'salesAmount', headerName: 'Sales Amount', width: 200 },
      { field: 'retailerTierStatus', headerName: 'Retailer Tier Status', width: 300 },
    ]
  }

  // On grid ready
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onSelectionChanged(e) {
    this.selectedRows = this.gridApi.getSelectedRows();

    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length > 0) {
      this.showUpdateRetailer = true;
      this.retailerTierId = this.selectedRows[0].retailerTierId;

      return
    }
    this.showUpdateRetailer = false;
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onDeleteTier() {
    this.retailerTierService.deleteTier(this.retailerTierId).subscribe(res => {
      if (res['httpcode'] == 200) {
        this.toastrService.success('Tier deleted succesfully', 'Success!')
        this.getAllTiersData()

      }
    })
  }


}
